import { render, staticRenderFns } from "./list.vue?vue&type=template&id=0905c3b6&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0905c3b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0905c3b6')) {
      api.createRecord('0905c3b6', component.options)
    } else {
      api.reload('0905c3b6', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=0905c3b6&scoped=true", function () {
      api.rerender('0905c3b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/creditInfo/portalAdministrativePenalties/list.vue"
export default component.exports